import { createSelector } from '@reduxjs/toolkit';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'data';
import { TemplateId } from 'data/templates/api';
import { TemplateAllocation } from '../types';
import { useActiveTemplateId } from './use-active-project-template';

const getAllAllocations = () =>
  createSelector(
    (state: RootState) => state.templates.project,
    (_, templateId: TemplateId) => templateId,
    (project, templateId): { [key: string]: TemplateAllocation } =>
      project.data[templateId].allocations,
  );

export const useGetAllAllocations = (): {
  [key: string]: TemplateAllocation;
} => {
  const templateId = useActiveTemplateId();
  const templateObject = useMemo(getAllAllocations, []);

  return useSelector((state: RootState) => templateObject(state, templateId));
};
